import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import MuiCssBaseline from "./MuiCssBaseline";
import MuiOutlinedInput from "./MuiOutlinedInput";
import MuiFormHelperText from "./MuiFormHelperText";
import MuiButton from "./MuiButton";
import MuiBackdrop from "./MuiBackdrop";
import MuiSlider from "./MuiSlider";
import MuiDialog from "./MuiDialog";

export default {
  ...MuiCssBaseline,
  ...MuiOutlinedInput,
  ...MuiFormHelperText,
  ...MuiButton,
  ...MuiBackdrop,
  ...MuiDialog,
  ...MuiSlider,
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
      disableTouchRipple: true,
    },
  },
  MuiIconButton: {
    defaultProps: {
      disableRipple: true,
      disableFocusRipple: true,
    },
  },
  MuiTab: {
    defaultProps: {
      disableRipple: true,
      disableFocusRipple: true,
      disableTouchRipple: true,
    },
  },
  MuiTableSortLabel: {
    defaultProps: {
      IconComponent: ArrowDropDownIcon,
    },
  },
  MuiWithWidth: {
    defaultProps: {
      // Initial width property
      initialWidth: "lg", // Breakpoint being globally set 🌎!
    },
  },
  MuiAppBar: {
    defaultProps: {
      elevation: 0,
    },
  },
  MuiPaper: {
    defaultProps: {
      elevation: 0,
    },
  },
  MuiTextField: {
    defaultProps: {
      fullWidth: true,
      variant: "outlined",
    },
  },
};
